// Runs on the initial page load and after every Turbo visit.
// Entrypoints that do not load Turbo only get the initial run, so callbacks must be idempotent.
export function onPageLoad(callback: () => void) {
  document.addEventListener("DOMContentLoaded", callback);
  document.addEventListener("turbo:load", callback);
}
